// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngx-slider .ngx-slider-bar {
  background: #f0f0f0 !important;
  height: 4px !important;
  border-radius: 2px !important;
}
.ngx-slider .ngx-slider-selection {
  background: #666 !important;
  border-radius: 1px !important;
  height: 1px !important;
}
.ngx-slider .ngx-slider-pointer {
  width: 16px !important;
  height: 16px !important;
  border-radius: 50% !important;
  background: #d4af37 !important;
  border: 1px solid black !important;
  box-shadow: 0 1px 4px rgba(255, 255, 255, 0.15) !important;
  transition: transform 0.2s ease !important;
}
.ngx-slider .ngx-slider-pointer:hover {
  transform: scale(1.05) !important;
}
.ngx-slider .ngx-slider-pointer::after {
  background-color: #d4af37 !important;
  border: black;
}
.ngx-slider .ngx-slider-tick {
  width: 1px !important;
  height: 6px !important;
  background: #ddd !important;
}
.ngx-slider .ngx-slider-tick.ngx-slider-selected {
  background-color: #d4af37 !important;
}
.ngx-slider .ngx-slider-limit {
  color: #666 !important;
  font-size: 11px !important;
}
.ngx-slider .ngx-slider-bubble {
  background: white !important;
  color: black !important;
  border-radius: 2px !important;
  padding: 2px 4px !important;
  font-size: 11px !important;
}

.mat-checkbox input[type=checkbox]:checked + .mat-checkbox-background, .mat-checkbox.mat-checkbox-checked .mat-checkbox-background, .mat-checkbox.mat-checkbox-indeterminate .mat-checkbox-background, .mat-checkbox.mat-accent .mat-checkbox-background, .mat-checkbox.mat-primary .mat-checkbox-background {
  background-color: #d4af37 !important;
  border-color: #d4af37 !important;
}
.mat-checkbox:hover .mat-checkbox-frame {
  border-color: #d4af37 !important;
}
.mat-checkbox:hover .mat-checkbox-ripple .mat-ripple-element {
  background-color: rgba(212, 175, 55, 0.1) !important;
}
.mat-checkbox .mat-checkbox-ripple .mat-ripple-element {
  background-color: rgba(212, 175, 55, 0.1) !important;
}
.mat-checkbox svg,
.mat-checkbox path,
.mat-checkbox circle {
  fill: #d4af37 !important;
  stroke: #d4af37 !important;
}

.mat-radio-button input[type=radio]:checked ~ .mat-radio-container .mat-radio-inner-circle, .mat-radio-button.mat-radio-checked .mat-radio-inner-circle, .mat-radio-button.mat-accent .mat-radio-inner-circle, .mat-radio-button.mat-primary .mat-radio-inner-circle {
  background-color: #d4af37 !important;
}
.mat-radio-button input[type=radio]:checked ~ .mat-radio-container .mat-radio-outer-circle, .mat-radio-button.mat-radio-checked .mat-radio-outer-circle, .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle, .mat-radio-button.mat-primary.mat-radio-checked .mat-radio-outer-circle {
  border-color: #d4af37 !important;
}
.mat-radio-button .mat-radio-ripple .mat-ripple-element {
  background-color: rgba(212, 175, 55, 0.1) !important;
}
.mat-radio-button svg,
.mat-radio-button path,
.mat-radio-button circle {
  fill: #d4af37 !important;
  stroke: #d4af37 !important;
}

* {
  --mat-checkbox-ripple-color: rgba(212, 175, 55, 0.1) !important;
  --mat-radio-ripple-color: rgba(212, 175, 55, 0.1) !important;
}

.mat-ripple-element {
  background-color: rgba(212, 175, 55, 0.1) !important;
}

[class*=mat-checkbox] [class*=background] {
  background-color: #d4af37 !important;
}

[class*=mat-radio] [class*=inner-circle] {
  background-color: #d4af37 !important;
}

[class*=mat-radio][class*=checked] [class*=outer-circle] {
  border-color: #d4af37 !important;
}

div[class*=mat-checkbox] div[class*=background],
div[class*=mat-radio] div[class*=inner] {
  background: #d4af37 !important;
}

.mdc-checkbox:hover .mdc-checkbox__ripple,
.mdc-radio:hover .mdc-radio__ripple {
  background-color: rgba(212, 175, 55, 0.1) !important;
}

::ng-deep .mat-mdc-checkbox.feature-checkbox,
::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox,
::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox__ripple {
  --mdc-checkbox-selected-icon-color: #d4af37;
  --mdc-checkbox-selected-hover-icon-color: black;
  --mdc-checkbox-selected-focus-icon-color: black;
  --mdc-checkbox-selected-pressed-icon-color: #d4af37;
  --mdc-checkbox-selected-hover-state-layer-color: rgba(212,175,55,0.1);
  --mdc-checkbox-selected-focus-state-layer-color: rgba(212,175,55,0.1);
  --mdc-checkbox-selected-pressed-state-layer-color: rgba(212,175,55,0.1);
  --mdc-checkbox-unselected-hover-icon-color: #d4af37;
  --mdc-checkbox-unselected-hover-state-layer-color: rgba(212,175,55,0.1);
}

::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox__ripple::before {
  background-color: rgba(212, 175, 55, 0.1) !important;
}

:root {
  --mdc-checkbox-selected-icon-color: #d4af37;
  --mdc-checkbox-selected-hover-icon-color: #fff;
  --mdc-checkbox-selected-hover-state-layer-color: #d4af37;
  --mdc-checkbox-selected-state-layer-color: #fff;
  --mdc-checkbox-unselected-hover-state-layer-color: rgba(212, 175, 55, 0.1);
  --mdc-checkbox-unselected-hover-icon-color: #d4af37;
  --mdc-checkbox-unselected-state-layer-color: #d4af37;
  --mdc-radio-selected-icon-color: #d4af37;
  --mdc-radio-selected-hover-icon-color: #d4af37;
  --mdc-radio-unselected-hover-icon-color: #d4af37;
}

.checkbox-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  --mdc-checkbox-selected-hover-state-layer-color: rgba(212,175,55,0.1);
  --mdc-checkbox-selected-focus-state-layer-color: rgba(212,175,55,0.1);
  --mdc-checkbox-selected-pressed-state-layer-color: rgba(212,175,55,0.1);
}

.sidenav-container {
  height: 100%;
  min-height: 100vh;
}

.sidenav {
  width: 250px;
}

.menu-button {
  margin: 8px;
}

/* Make sidenav full-height */
.sidenav-content {
  height: 100%;
  padding: 16px;
}

.main-content {
  padding: 16px;
}

.right-btn {
  background: lightgray !important;
  color: black !important;
  font-weight: 300;
  font-family: "Helvetica Neue", Arial, sans-serif;
  letter-spacing: 1px;
  border-radius: 20px;
  padding: 0 20px;
  box-shadow: 0 4px 15px black;
  transition: all 0.3s ease;
}
.right-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  background: linear-gradient(45deg, #d4af37, #b8860b, black);
}
.right-btn mat-icon {
  margin-right: 8px;
}

.info-btn {
  background: black !important;
  color: #1a1a1a;
  font-weight: 300;
  font-family: "Helvetica Neue", Arial, sans-serif;
  letter-spacing: 1px;
  border-radius: 20px;
  padding: 0 20px;
  box-shadow: 0 4px 15px black;
  transition: all 0.3s ease;
}
.info-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);
  background: linear-gradient(45deg, #d4af37, #b8860b, black);
}
.info-btn mat-icon {
  margin-right: 8px;
}

.sell-btn {
  background: linear-gradient(45deg, #d4af37, #b8860b);
  color: #1a1a1a;
  font-weight: 300;
  font-family: "Helvetica Neue", Arial, sans-serif;
  letter-spacing: 1px;
  border-radius: 20px;
  padding: 0 20px;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
  transition: all 0.3s ease;
}
.sell-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);
  background: linear-gradient(45deg, #daa520, #cd853f);
}
.sell-btn mat-icon {
  margin-right: 8px;
}

/* Media query for mobile devices */
@media (max-width: 768px) {
  .sidenav {
    width: 100%;
    max-width: 300px;
  }
}
.black-button {
  background-color: black !important;
  color: white !important;
}

.black-button:hover {
  background-color: black !important;
}

.gray-button {
  background-color: transparent !important;
  color: black !important;
}

.gray-button:hover {
  color: #949494 !important;
}

.orange {
  color: #d4af37 !important;
}

.mdc-text-field--focused .mdc-floating-label {
  color: #d4af37 !important;
}

.mat-mdc-select-value {
  color: #d4af37 !important;
}

.mat-mdc-option.mdc-list-item--selected {
  color: #d4af37 !important;
  font-weight: bold;
}

.mat-mdc-form-field.mat-focused .mdc-line-ripple {
  background-color: #d4af37 !important;
}

.cdk-overlay-container .mat-mdc-select-panel .mat-mdc-option[aria-selected=true] {
  color: #d4af37 !important;
  font-weight: bold !important;
}

::ng-deep .mat-mdc-form-field.mat-focused .mat-mdc-select-arrow {
  color: #d4af37 !important;
}

.mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--activated) .mdc-list-item__primary-text {
  color: #d4af37 !important;
  font-weight: bold !important;
}

::ng-deep .mat-mdc-option[aria-selected=true].mdc-list-item:not(.mdc-list-item--activated) .mdc-list-item__primary-text {
  color: #d4af37 !important;
  font-weight: bold !important;
}

::ng-deep .mat-mdc-option[aria-selected=true] .mat-pseudo-checkbox {
  color: #d4af37 !important;
  --mdc-checkbox-selected-icon-color: #d4af37 !important;
  --mdc-checkbox-selected-checkmark-color: #d4af37 !important;
}

::ng-deep .mat-mdc-option .mat-pseudo-checkbox {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/listing-browse-ui/mat-checkbox.scss"],"names":[],"mappings":"AAIE;EACE,8BAAA;EACA,sBAAA;EACA,6BAAA;AAHJ;AAME;EACE,2BAAA;EACA,6BAAA;EACA,sBAAA;AAJJ;AAOE;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;EACA,kCAAA;EACA,0DAAA;EACA,0CAAA;AALJ;AAOI;EACE,iCAAA;AALN;AAQI;EACE,oCAAA;EACA,aAAA;AANN;AAUE;EACE,qBAAA;EACA,sBAAA;EACA,2BAAA;AARJ;AAUI;EACE,oCAAA;AARN;AAYE;EACE,sBAAA;EACA,0BAAA;AAVJ;AAaE;EACE,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;AAXJ;;AAiBE;EAKE,oCAAA;EACA,gCAAA;AAlBJ;AAsBI;EACE,gCAAA;AApBN;AAuBI;EACE,oDAAA;AArBN;AAyBE;EACE,oDAAA;AAvBJ;AA0BE;;;EAGE,wBAAA;EACA,0BAAA;AAxBJ;;AA8BE;EAIE,oCAAA;AA9BJ;AAiCE;EAIE,gCAAA;AAlCJ;AAqCE;EACE,oDAAA;AAnCJ;AAsCE;;;EAGE,wBAAA;EACA,0BAAA;AApCJ;;AAyCA;EACE,+DAAA;EACA,4DAAA;AAtCF;;AAyCA;EACE,oDAAA;AAtCF;;AA0CA;EACE,oCAAA;AAvCF;;AA0CA;EACE,oCAAA;AAvCF;;AA0CA;EACE,gCAAA;AAvCF;;AA0CA;;EAEE,8BAAA;AAvCF;;AA2CA;;EAEE,oDAAA;AAxCF;;AA2CA;;;EAGE,2CAAA;EACA,+CAAA;EACA,+CAAA;EACA,mDAAA;EAEA,qEAAA;EACA,qEAAA;EACA,uEAAA;EAEA,mDAAA;EACA,uEAAA;AA1CF;;AA6CA;EACE,oDAAA;AA1CF;;AA8CA;EACE,2CAAA;EACA,8CAAA;EACA,wDAAA;EACA,+CAAA;EACA,0EAAA;EACA,mDAAA;EACA,oDAAA;EAEA,wCAAA;EACA,8CAAA;EACA,gDAAA;AA5CF;;AA8CA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qEAAA;EACA,qEAAA;EACA,uEAAA;AA3CF;;AA8CA;EACE,YAAA;EACA,iBAAA;AA3CF;;AA8CA;EACE,YAAA;AA3CF;;AA8CA;EACE,WAAA;AA3CF;;AA8CA,6BAAA;AACA;EACE,YAAA;EACA,aAAA;AA3CF;;AA8CA;EACE,aAAA;AA3CF;;AA+CA;EACE,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;AA5CF;AA8CE;EACE,2BAAA;EACA,yCAAA;EACA,2DAAA;AA5CJ;AA+CE;EACE,iBAAA;AA7CJ;;AAiDA;EACE,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;AA9CF;AAgDE;EACE,2BAAA;EACA,8CAAA;EACA,2DAAA;AA9CJ;AAiDE;EACE,iBAAA;AA/CJ;;AAmDA;EACE,oDAAA;EACA,cAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;EACA,yBAAA;AAhDF;AAkDE;EACE,2BAAA;EACA,8CAAA;EACA,oDAAA;AAhDJ;AAmDE;EACE,iBAAA;AAjDJ;;AAqDA,mCAAA;AACA;EACE;IACE,WAAA;IACA,gBAAA;EAlDF;AACF;AAqDA;EACE,kCAAA;EACA,uBAAA;AAnDF;;AAsDA;EACE,kCAAA;AAnDF;;AAsDA;EACE,wCAAA;EACA,uBAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;EACA,iBAAA;AAnDF;;AAsDA;EACE,oCAAA;AAnDF;;AAsDA;EACE,yBAAA;EACA,4BAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;EACA,4BAAA;AAnDF;;AAsDA;EAEE,yBAAA;EACA,4BAAA;AApDF;;AAuDA;EACE,yBAAA;EACA,sDAAA;EACA,2DAAA;AApDF;;AAuDA;EACE,wBAAA;AApDF","sourcesContent":["\n\n// NGX Slider Styles\n.ngx-slider {\n  .ngx-slider-bar {\n    background: #f0f0f0 !important;\n    height: 4px !important;\n    border-radius: 2px !important;\n  }\n\n  .ngx-slider-selection {\n    background: #666 !important;\n    border-radius: 1px !important;\n    height: 1px !important;\n  }\n\n  .ngx-slider-pointer {\n    width: 16px !important;\n    height: 16px !important;\n    border-radius: 50% !important;\n    background: #d4af37 !important;\n    border: 1px solid black !important;\n    box-shadow: 0 1px 4px rgba(255, 255, 255, 0.15) !important;\n    transition: transform 0.2s ease !important;\n\n    &:hover {\n      transform: scale(1.05) !important;\n    }\n\n    &::after {\n      background-color: #d4af37 !important;\n      border: black;\n    }\n  }\n\n  .ngx-slider-tick {\n    width: 1px !important;\n    height: 6px !important;\n    background: #ddd !important;\n\n    &.ngx-slider-selected {\n      background-color: #d4af37 !important;\n    }\n  }\n\n  .ngx-slider-limit {\n    color: #666 !important;\n    font-size: 11px !important;\n  }\n\n  .ngx-slider-bubble {\n    background: white !important;\n    color: black !important;\n    border-radius: 2px !important;\n    padding: 2px 4px !important;\n    font-size: 11px !important;\n  }\n}\n\n// Checkbox Customization\n.mat-checkbox {\n  input[type='checkbox']:checked + .mat-checkbox-background,\n  &.mat-checkbox-checked .mat-checkbox-background,\n  &.mat-checkbox-indeterminate .mat-checkbox-background,\n  &.mat-accent .mat-checkbox-background,\n  &.mat-primary .mat-checkbox-background {\n    background-color: #d4af37 !important;\n    border-color: #d4af37 !important;\n  }\n\n  &:hover {\n    .mat-checkbox-frame {\n      border-color: #d4af37 !important;\n    }\n\n    .mat-checkbox-ripple .mat-ripple-element {\n      background-color: rgba(212, 175, 55, 0.1) !important;\n    }\n  }\n\n  .mat-checkbox-ripple .mat-ripple-element {\n    background-color: rgba(212, 175, 55, 0.1) !important;\n  }\n\n  svg,\n  path,\n  circle {\n    fill: #d4af37 !important;\n    stroke: #d4af37 !important;\n  }\n}\n\n// Radio Button Customization\n.mat-radio-button {\n  input[type='radio']:checked ~ .mat-radio-container .mat-radio-inner-circle,\n  &.mat-radio-checked .mat-radio-inner-circle,\n  &.mat-accent .mat-radio-inner-circle,\n  &.mat-primary .mat-radio-inner-circle {\n    background-color: #d4af37 !important;\n  }\n\n  input[type='radio']:checked ~ .mat-radio-container .mat-radio-outer-circle,\n  &.mat-radio-checked .mat-radio-outer-circle,\n  &.mat-accent.mat-radio-checked .mat-radio-outer-circle,\n  &.mat-primary.mat-radio-checked .mat-radio-outer-circle {\n    border-color: #d4af37 !important;\n  }\n\n  .mat-radio-ripple .mat-ripple-element {\n    background-color: rgba(212, 175, 55, 0.1) !important;\n  }\n\n  svg,\n  path,\n  circle {\n    fill: #d4af37 !important;\n    stroke: #d4af37 !important;\n  }\n}\n\n// Global Material Checkbox & Radio Overrides (Nuclear Option)\n* {\n  --mat-checkbox-ripple-color: rgba(212, 175, 55, 0.1) !important;\n  --mat-radio-ripple-color: rgba(212, 175, 55, 0.1) !important;\n}\n\n.mat-ripple-element {\n  background-color: rgba(212, 175, 55, 0.1) !important;\n}\n\n// Deep Structural Overrides\n[class*='mat-checkbox'] [class*='background'] {\n  background-color: #d4af37 !important;\n}\n\n[class*='mat-radio'] [class*='inner-circle'] {\n  background-color: #d4af37 !important;\n}\n\n[class*='mat-radio'][class*='checked'] [class*='outer-circle'] {\n  border-color: #d4af37 !important;\n}\n\ndiv[class*='mat-checkbox'] div[class*='background'],\ndiv[class*='mat-radio'] div[class*='inner'] {\n  background: #d4af37 !important;\n}\n\n// MDC Checkbox & Radio Ripple Hover\n.mdc-checkbox:hover .mdc-checkbox__ripple,\n.mdc-radio:hover .mdc-radio__ripple {\n  background-color: rgba(212, 175, 55, 0.1) !important;\n}\n\n::ng-deep .mat-mdc-checkbox.feature-checkbox,\n::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox,\n::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox__ripple {\n  --mdc-checkbox-selected-icon-color: #d4af37;\n  --mdc-checkbox-selected-hover-icon-color: black;\n  --mdc-checkbox-selected-focus-icon-color: black;\n  --mdc-checkbox-selected-pressed-icon-color: #d4af37;\n\n  --mdc-checkbox-selected-hover-state-layer-color: rgba(212,175,55,0.1);\n  --mdc-checkbox-selected-focus-state-layer-color: rgba(212,175,55,0.1);\n  --mdc-checkbox-selected-pressed-state-layer-color: rgba(212,175,55,0.1);\n\n  --mdc-checkbox-unselected-hover-icon-color: #d4af37;\n  --mdc-checkbox-unselected-hover-state-layer-color: rgba(212,175,55,0.1);\n}\n\n::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox__ripple::before {\n  background-color: rgba(212, 175, 55, 0.1) !important;\n}\n\n// CSS Custom Properties (Material Design Tokens)\n:root {\n  --mdc-checkbox-selected-icon-color: #d4af37;\n  --mdc-checkbox-selected-hover-icon-color: #fff;\n  --mdc-checkbox-selected-hover-state-layer-color: #d4af37;\n  --mdc-checkbox-selected-state-layer-color: #fff;\n  --mdc-checkbox-unselected-hover-state-layer-color: rgba(212, 175, 55, 0.1);\n  --mdc-checkbox-unselected-hover-icon-color: #d4af37;\n  --mdc-checkbox-unselected-state-layer-color: #d4af37;\n\n  --mdc-radio-selected-icon-color: #d4af37;\n  --mdc-radio-selected-hover-icon-color: #d4af37;\n  --mdc-radio-unselected-hover-icon-color: #d4af37;\n}\n.checkbox-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  --mdc-checkbox-selected-hover-state-layer-color: rgba(212,175,55,0.1);\n  --mdc-checkbox-selected-focus-state-layer-color: rgba(212,175,55,0.1);\n  --mdc-checkbox-selected-pressed-state-layer-color: rgba(212,175,55,0.1);\n}\n\n.sidenav-container {\n  height: 100%;\n  min-height: 100vh;\n}\n\n.sidenav {\n  width: 250px;\n}\n\n.menu-button {\n  margin: 8px;\n}\n\n/* Make sidenav full-height */\n.sidenav-content {\n  height: 100%;\n  padding: 16px;\n}\n\n.main-content {\n  padding: 16px;\n}\n\n\n.right-btn {\n  background: lightgray !important;\n  color: black !important;\n  font-weight: 300;\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  letter-spacing: 1px;\n  border-radius: 20px;\n  padding: 0 20px;\n  box-shadow: 0 4px 15px black;\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\n    background: linear-gradient(45deg, #d4af37, #b8860b, black);\n  }\n\n  mat-icon {\n    margin-right: 8px;\n  }\n}\n\n.info-btn {\n  background: black !important;\n  color: #1a1a1a;\n  font-weight: 300;\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  letter-spacing: 1px;\n  border-radius: 20px;\n  padding: 0 20px;\n  box-shadow: 0 4px 15px black;\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);\n    background: linear-gradient(45deg, #d4af37, #b8860b, black);\n  }\n\n  mat-icon {\n    margin-right: 8px;\n  }\n}\n\n.sell-btn {\n  background: linear-gradient(45deg, #d4af37, #b8860b);\n  color: #1a1a1a;\n  font-weight: 300;\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  letter-spacing: 1px;\n  border-radius: 20px;\n  padding: 0 20px;\n  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);\n    background: linear-gradient(45deg, #daa520, #cd853f);\n  }\n\n  mat-icon {\n    margin-right: 8px;\n  }\n}\n\n/* Media query for mobile devices */\n@media (max-width: 768px) {\n  .sidenav {\n    width: 100%;\n    max-width: 300px;\n  }\n}\n\n.black-button {\n  background-color: black !important;\n  color: white !important;\n}\n\n.black-button:hover {\n  background-color: black !important; // slightly darker on hover\n}\n\n.gray-button {\n  background-color: transparent !important;\n  color: black !important;\n}\n\n.gray-button:hover {\n  color: #949494 !important; // slightly darker on hover\n}\n\n.orange {\n  color: #d4af37 !important; // slightly darker on hover\n}\n\n.mdc-text-field--focused .mdc-floating-label {\n  color: #d4af37 !important;\n}\n\n.mat-mdc-select-value {\n  color: #d4af37 !important;\n}\n\n.mat-mdc-option.mdc-list-item--selected {\n  color: #d4af37 !important;\n  font-weight: bold;\n}\n\n.mat-mdc-form-field.mat-focused .mdc-line-ripple {\n  background-color: #d4af37 !important;\n}\n\n.cdk-overlay-container .mat-mdc-select-panel .mat-mdc-option[aria-selected=\"true\"] {\n  color: #d4af37 !important; // ← TEXT COLOR\n  font-weight: bold !important;\n}\n\n::ng-deep .mat-mdc-form-field.mat-focused .mat-mdc-select-arrow {\n  color: #d4af37 !important;\n}\n\n.mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--activated) .mdc-list-item__primary-text {\n  color: #d4af37 !important;\n  font-weight: bold !important;\n}\n\n::ng-deep .mat-mdc-option[aria-selected=\"true\"].mdc-list-item:not(.mdc-list-item--activated)\n.mdc-list-item__primary-text {\n  color: #d4af37 !important;\n  font-weight: bold !important;\n}\n\n::ng-deep .mat-mdc-option[aria-selected=\"true\"] .mat-pseudo-checkbox {\n  color: #d4af37 !important;       // Fallback for legacy\n  --mdc-checkbox-selected-icon-color: #d4af37 !important; // MDC-based theming\n  --mdc-checkbox-selected-checkmark-color: #d4af37 !important;\n}\n\n::ng-deep .mat-mdc-option .mat-pseudo-checkbox {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
